import React, { useState, useEffect } from 'react'
import RowBarInternet from './RowBar_Internet';
import TCPIPSetting from './TCPIP_settings';
import WIFIIcon from '../Device/icon/WIFI_Icon';
import Radar from '../Device/icon/Radar';
import ApiGo from '../../../actions/ApiGo';
import { useTranslation } from 'react-i18next';


const InternetSettings =(props)=>{

    const {t} = useTranslation()

    const [refresh_current_wifi_after_change, setRefresh_current_wifi_after_change] = useState(false);
    const [tcpip_setting_block, setTcpip_setting_block] = useState(false);
    const [current_wifi_setting_essid, setCurrent_wifi_setting_essid] = useState('');
    const [current_wifi_setting_signal, setCurrent_wifi_setting_signal] = useState('');
    const [current_wifi_setting_mac, setCurrent_wifi_setting_mac] = useState('');
    const [scanning_wifi_result, setScanning_wifi_result] = useState([]);
    const [scan_wifi_bool, setScan_wifi_bool] = useState(false);
    const [open_WIFI_block, setOpen_WIFI_block] = useState(false);
    const [wrong_type, setWrong_type] = useState("nothing_happend");
    const [current_ip, setCurrent_ip] = useState('');
    const [current_netmask, setCurrent_netmask] = useState('');
    const [current_broadcast, setCurrent_broadcast] = useState('');
    // const [scanning_animation, setScanning_animation] = useState(false);

    function TCPIP_toggle() {
        setTcpip_setting_block(!tcpip_setting_block)
    }

    function refresh_toggle() {
        setRefresh_current_wifi_after_change(!refresh_current_wifi_after_change)
    }

    // 目前連線
    useEffect(() => {
        fetch_current_wifi().then(res=>{
            setCurrent_wifi_setting_essid(res.current_wifi_essid)
            setCurrent_wifi_setting_signal(res.current_wifi_signal)
            setCurrent_wifi_setting_mac(res.current_wifi_mac_address)
            setCurrent_ip(res.current_ip)
            setCurrent_netmask(res.current_netmask)
            setCurrent_broadcast(res.current_broadcast)
        }).catch(()=>{
            setCurrent_wifi_setting_mac(["connection lost"])
        })

    }, [refresh_current_wifi_after_change]);
    function fetch_current_wifi() {
        return new Promise((resolve, reject)=>{
            ApiGo.getCurrent_wifi_setting()
            .then(res=>{resolve(res);})
            .catch(err=>{reject(err);})
        })
    }
    function fetch_scan_wifi() {
        setScan_wifi_bool(true)
        ApiGo.get_wifi_info()
        .then(res=>{
            let arr = [0]
            res.forEach(cell=>{
                let count = 1
                for(let n of arr){
                    if(cell.ESSID===n.ESSID){ break; }
                    if(count===arr.length){ arr.push(cell) }
                    count++
                }
            })
            arr.splice(0,1)
            setScanning_wifi_result(arr)
            setScan_wifi_bool(false)
            setOpen_WIFI_block(true)
        })
        .catch(err=>{
            setScan_wifi_bool(false)
        })
    }

    return(
    <div className='grid grid-cols-2'>
        <div className="font-ml">
            {(scan_wifi_bool)?<ScanningAnimation scan_style={"scan"} wrong_type={wrong_type}/>:null}
            {(tcpip_setting_block)?<TCPIPSetting hide={TCPIP_toggle} setWrong_type={setWrong_type}/>:null}
                <div className="fx-d-r fx-fsc font-l">{t("ADMIN.NETWORK_SETTING.CURRENT_CONNECTION")}</div>
                <div className='fx-d-c bgC-white wid-admin-25 hig-auto br-20 shadow-s-noHover pad-15 t b'>
                {/* <div onClick={redirect}>click!</div> */}
                {/* <div className="fx-d-r wid-admin-60 fx-fsc margt-xs">
                    <div className="w-30 fx-ccc">{t("ADMIN.NETWORK_SETTING.SIGNAL")}</div>
                    <div className="w-30 fx-ccc">{t("ADMIN.NETWORK_SETTING.WIFI_NAME")}</div>
                    <div className="w-30 fx-ccc">{t("ADMIN.NETWORK_SETTING.WIFI_MAC")}</div>
                </div> */}
                <div className="fx-d-r wid-100 fx-fsc margb-xxs">
                    <div className="fx-d-r fx-ccc w-30">
                        <div className="wid-admin-xxs trans_y10"><WIFIIcon rssi={current_wifi_setting_signal} size={"s"}/></div>
                        <div className="font-s pos-a trans_rssi">{current_wifi_setting_signal}</div>
                        {/* <div className="fx-d-r margl-xs">{(current_wifi_setting_signal>-50)?t("ADMIN.NETWORK_SETTING.GREAT")+" : ":(current_wifi_setting_signal>-60)?t("ADMIN.NETWORK_SETTING.GOOD")+" : ":(current_wifi_setting_signal>-70)?t("ADMIN.NETWORK_SETTING.POOR")+" : ":t("ADMIN.NETWORK_SETTING.BAD")+" :"}{current_wifi_setting_signal}</div> */}
                    </div>
                    <div className='fx-d-c w-60'>
                        <div className="fx-ccc">{current_wifi_setting_essid}</div>
                        <div className="fx-ccc font-m">{current_wifi_setting_mac}</div>
                    </div>
                </div>
            </div>
            <div className="font-l margt-xs fx-d-r fx-fsc">
                <div>{t("ADMIN.NETWORK_SETTING.ADVANCE_NETWORK_SETTING")}</div>
                <div className="wid-admin-xs hig-xs bgC-alert-E br-10 shadow-s fx-cc margl-xs font-l cursor_style pointer" onClick={TCPIP_toggle}>{t("ADMIN.NETWORK_SETTING.CONFIG")}</div>
            </div>
            <div className="margt-xs fx-d-r fx-fsc">
                <div className="font-l">{t("ADMIN.NETWORK_SETTING.AVAILABLE_WIFI")}</div>
                <div className="fx-cc margl-xs shadow-s font-l bgC-alert-E wid-admin-xs hig-xs br-10 cursor_style pointer"
                        onClick={fetch_scan_wifi}>{t("ADMIN.NETWORK_SETTING.SEARCH")}</div>
                </div>
            <div className="wid-admin-25 bgC-white br-20 shadow-s-noHover margt-xs pad-10px">
                <div className='hig-45 of-auto post-r'>
                    {scanning_wifi_result.map((wifi,index)=>{
                        return <RowBarInternet
                            key={wifi.ESSID+index}
                            wifi={wifi.ESSID}
                            auth_suites={wifi.auth_suites}
                            encryption={wifi.encryption}
                            pair_ciper={wifi.pair_ciper}
                            signal_level={wifi.signal_level}
                            wpa_type={wifi.wpa_type}
                            setRefresh_current_wifi_after_change={refresh_toggle}/>
                    })}
                </div>
            </div>
        </div>
        <div className='fx-d-c fx-fsfs bgC-white wid-admin-25 hig-auto br-20 shadow-s-noHover pad-15 t b l  6'>
            <div className='fx-d-c fx-cfs'>
                <div className="fx-fsc">current_ip</div>
                <div className="fx-ccc font-m">{current_ip}</div>
            </div>
            <div className='fx-d-c fx-fsc'>
                <div className="fx-ccc">current_netmask</div>
                <div className="fx-ccc font-m">{current_netmask}</div>
            </div>
            <div className='fx-d-c fx-fsc'>
                <div className="fx-ccc">current_broadcast</div>
                <div className="fx-ccc font-m">{current_broadcast}</div>
            </div>
        </div>
    </div>
    );

}

export const ScanningAnimation =(props)=>{
    const {t} = useTranslation()
    const [rssi, setRssi] = useState(-49);
    const context_list = [t("ADMIN.NETWORK_SETTING.CONNECTING_ATTEMPT"), t("ADMIN.NETWORK_SETTING.CONNECTING_TESTING"), t("ADMIN.NETWORK_SETTING.CONNECTING_STABLE"), t("ADMIN.NETWORK_SETTING.CONNECTED")]
    const [num, setNum] = useState(0);
    const [context, setContext] = useState(context_list[num]);
    useEffect(()=>{
        if(props.scan_style==="connecting"){
            setTimeout(()=>{
                window.location.reload()
            }, 30000)
        }
    }, [props.scan_style])
    useEffect(()=>{
        if(props.scan_style==="connecting"){
            setTimeout(()=>{
                let a = rssi
                a = a+10
                if(a>-40){
                    a=-70
                }
                setRssi(a)
            },500)
            setTimeout(()=>{
                setContext(context_list[num])
                let a = num+1
                setNum(a)
            }, 9000)
        }
    },[props.scan_style, rssi, context_list, num])
    useEffect(()=>{console.log(props)}, [props])
    return(
        <div className={`wid-admin-full hig-full pos-a ${(props.scan_style==="scan")?"top--10 left--10":""} fx-cc`} onClick={e=>{(props.wrong_type==="wrong_input_type")?props.hide():e.stopPropagation()}}>
            <div className={`wid-admin-m br-20 fx-d-c fx-cc shadow-s-noHover ${(props.scan_style==="scan")?"hig-l bgC-white":"hig-l bgC-alert-E"}`}>
                <div className="">{(props.wrong_type==="nothing_happend")?<div><div className="fx-cc hig-s"><Radar rssi={rssi} style={props.scan_style}/></div>
                    {(props.scan_style==="scan")?
                        <div className="margt-6-vh fx-d-c fx-cc" style={{ textAlign: 'center' }}>
                            <div>
                                {t("ADMIN.NETWORK_SETTING.SCANNING")}
                            </div>
                            <div className="running_dot margt-s">
                                {t("ADMIN.NETWORK_SETTING.PLEASE_WAIT")}
                            </div>
                        </div>:null}
                    {(props.scan_style==="connecting")?
                        <div className="margt-22  fx-d-c fx-cc" style={{ textAlign: 'center' }}>
                            {t("ADMIN.NETWORK_SETTING.CONNECTING_WAIT")}
                            <div className="margt-s running_dot">{context}</div>
                        </div>:null}
                </div>:(props.wrong_type==="wrong_input_type")?
                    <div className="fx-d-c fx-cc">{t("ADMIN.NETWORK_SETTING.WRONG_FORMAT")}
                        <div className="fx-cc shadow-s margt-s bgC-alert-EE br-10 wid-admin-xs hig-xs" onClick={props.hide}>{t("GLOBAL.CONFIRM")}</div>
                    </div>:
                    (props.wrong_type==="wrong_pwd")?
                        <div className="fx-d-c fx-cc" style={{ textAlign: 'center' }}>
                            <div>{t("ADMIN.NETWORK_SETTING.WRONG_PWD")}</div>
                            <div>{t("ADMIN.NETWORK_SETTING.RESET_DEFAULT")}</div>
                            <div className="fx-cc shadow-s margt-s bgC-alert-EE br-10 wid-admin-xs hig-xs" onClick={props.hide}>{t("GLOBAL.CONFIRM")}</div>
                        </div>:null}
                </div>
            </div>
        </div>
    )
}


export default InternetSettings;

